import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  NavWrapper,
  Name,
  NavSection,
  Nav,
  MenuIcon,
  MenuIconWrapper
} from './NavHeader.style';
import {Link} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';
import {FormattedMessage} from 'react-intl';
import Hamburger from '../Hamburger/Hamburger';

export default class NavHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isClosed: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState({isClosed: !this.state.isClosed});
  }

  render() {
    const {name, template, style, isOpen, modes, transparent, goHome, isAddOn, navUrls} = this.props;
    const renderNavs =
      template &&
      template.light &&
      template.light.homeBlocks &&
      template.light.homeBlocks.map((block, i) => {
        return block.navigationTitle && (
          <HashLink
            key={block.title + i}
            to={`${navUrls.homeUrl}#${block.navigationTitle}`}
          >
            <Nav transparent={transparent}>
              {block.navigationTitle}
            </Nav>
          </HashLink>
        );
      });
    const renderContactUs =
      template &&
      template.light &&
      template.light.openingTimes && (
        <HashLink to={navUrls.contactUsUrl}>
          <Nav transparent={transparent}>
            <FormattedMessage id="header.nav.contact" />
          </Nav>
        </HashLink>
     );
    const renderBooking = modes.tableBooking && (
      <Link to={navUrls.bookingUrl}>
        <Nav transparent={transparent}>
          <FormattedMessage id="header.nav.book" />
        </Nav>
      </Link>
    );
    const renderNavSection = !isAddOn && (
      <NavSection isOpen={this.state.isClosed} >
        <Nav
          onClick={goHome}
          transparent={transparent}
        >
          <FormattedMessage id="header.nav.home" />
        </Nav>
        <Link to={navUrls.menuUrl}>
          <Nav transparent={transparent}>
            <FormattedMessage id={isOpen && modes && modes.onlineOrdering ? 'header.nav.order' : 'header.nav.menu'} />
          </Nav>
        </Link>
        {renderNavs}
        {renderBooking}
        {renderContactUs}
      </NavSection>
    );
    const renderIcon = !isAddOn && (
      <MenuIconWrapper onClick={this.toggleMenu}>
        <MenuIcon>
          <Hamburger isClosed={this.state.isClosed} />
        </MenuIcon>
      </MenuIconWrapper>
    );
    return (
      <Wrapper
        style={style}
        transparent={transparent}
        data-rw="light-nav-header-content"
      >
        <NavWrapper>
          <Name onClick={goHome}>{name}</Name>
          {renderNavSection}
        </NavWrapper>
        {renderIcon}
      </Wrapper>
    );
  }
}

NavHeader.propTypes = {
  name: PropTypes.string.isRequired,
  template: PropTypes.object.isRequired,
  modes: PropTypes.object,
  style: PropTypes.object,
  isOpen: PropTypes.bool,
  transparent: PropTypes.bool,
  isAddOn: PropTypes.bool,
  goHome: PropTypes.func.isRequired,
  navUrls: PropTypes.object
};



// WEBPACK FOOTER //
// ./components/LightHeader/NavHeader.js